(function () {
  if (customElements.get('ttl-ba-reviews')) return;

  var DRAG_THRESHOLD = 6;
  var JM_API = 'https://judge.me/api/v1/widgets/all_reviews_page';
  var STAR_PATH =
    '<path d="M12 2.2l2.86 5.8 6.4.93-4.63 4.51 1.09 6.37L12 16.8l-5.72 3.01 1.09-6.37L2.74 8.93l6.4-.93L12 2.2Z"/>';
  var CHECK_SVG =
    '<svg class="ttl-bar__check" viewBox="0 0 16 16" width="13" height="13" fill="none" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="8" fill="currentColor"></circle><path d="M4.5 8.2l2.2 2.2 4.8-4.8" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  var ARROW_SVG =
    '<svg class="ttl-bar__product-arrow" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function picUrl(p) {
    if (!p) return '';
    if (typeof p === 'string') return p;
    var u = p.urls || p;
    return u.huge || u.original || u.large || u.compact || u.small || u.hidden || p.url || '';
  }

  function picturesOf(r) {
    if (!r) return [];
    var list = r.pictures_urls || r.picture_urls || r.pictures || r.media || [];
    var out = [];
    var i;
    for (i = 0; i < list.length; i++) {
      var url = picUrl(list[i]);
      if (url) out.push(url);
    }
    return out;
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || d.innerText || '').trim();
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var CURE_HANDLES = {
    'la-cure-miracle': true,
    'cure-croissance-cils': true
  };
  var SERUM_HANDLE = 'serum-tothelash';

  function defaultReviewLabels() {
    var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    if (lang === 'en') {
      return { serum: 'Serum tothelash', cure: 'Cure Miracle' };
    }
    if (lang === 'de') {
      return { serum: 'tothelash Serum', cure: 'Cure Miracle' };
    }
    return { serum: 'Sérum tothelash', cure: 'Cure Miracle' };
  }

  function reviewLabelsFromRoot(root) {
    var labels = defaultReviewLabels();
    if (!root || !root.getAttribute) return labels;
    var serum = root.getAttribute('data-label-serum');
    var cure = root.getAttribute('data-label-cure');
    if (serum) labels.serum = serum;
    if (cure) labels.cure = cure;
    return labels;
  }

  function isLegacyMascara(handle, title, url) {
    var h = (handle || '').toLowerCase();
    var t = (title || '').toLowerCase();
    var u = (url || '').toLowerCase();
    if (/mascara/.test(h) || /mascara/.test(u)) return true;
    if (/\bmascara\b/.test(t)) return true;
    if (/tubing/.test(t) && /tothe/.test(t)) return true;
    if (/lifting/.test(t) && /mascara/.test(t)) return true;
    return false;
  }

  function isCureProduct(handle, title) {
    var h = (handle || '').toLowerCase();
    var t = (title || '').toLowerCase();
    if (CURE_HANDLES[h]) return true;
    if (/cure/.test(t) && !/\bmascara\b/.test(t)) return true;
    if (/3\s*s[ée]rums?/.test(t)) return true;
    return false;
  }

  function applyReviewDisplay(review, labels) {
    if (!review) return review;
    labels = labels || defaultReviewLabels();
    review.verified = true;

    var handle = (review.product_handle || '').toLowerCase();
    var title = review.product_title || '';
    var titleDown = title.toLowerCase();
    var url = review.product_url || '';

    if (isLegacyMascara(handle, titleDown, url)) {
      review.product_title = labels.serum;
      review.product_handle = SERUM_HANDLE;
      review.product_url = '/products/serum-tothelash';
      return review;
    }

    if (isCureProduct(handle, titleDown)) {
      review.product_title = labels.cure;
      review.product_handle = SERUM_HANDLE;
      review.product_url = '/products/serum-tothelash?pack=3';
      return review;
    }

    if (handle === SERUM_HANDLE || /s[ée]rum/.test(titleDown)) {
      review.product_title = labels.serum;
      review.product_handle = SERUM_HANDLE;
      if (!url || isLegacyMascara(handle, titleDown, url)) {
        review.product_url = '/products/serum-tothelash';
      }
      return review;
    }

    if (/\bmascara\b/i.test(title)) {
      review.product_title = labels.serum;
      review.product_handle = SERUM_HANDLE;
      review.product_url = '/products/serum-tothelash';
    }

    return review;
  }

  window.ttlApplyReviewDisplay = applyReviewDisplay;
  window.ttlReviewLabelsFromRoot = reviewLabelsFromRoot;

  function collectReviews(payload) {
    var out = [];
    if (!payload) return out;
    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload);
      } catch (e) {
        return out;
      }
    }
    var list = [];
    if (Array.isArray(payload)) list = payload;
    else if (Array.isArray(payload.reviews)) list = payload.reviews;
    else if (Array.isArray(payload.photo_gallery)) list = payload.photo_gallery;
    else if (payload.widget && Array.isArray(payload.widget.reviews)) list = payload.widget.reviews;
    else if (payload.widget && Array.isArray(payload.widget.photo_gallery)) {
      list = payload.widget.photo_gallery;
    }
    var i;
    for (i = 0; i < list.length; i++) {
      var r = list[i];
      if (!r) continue;
      var pics = picturesOf(r);
      if (!pics.length) continue;
      var reviewer = r.reviewer || {};
      var product = r.product || {};
      out.push(
        applyReviewDisplay(
          {
            id: String(r.uuid || r.id || pics[0]),
            rating: Number(r.rating) || 0,
            name: reviewer.name || reviewer.display_name || r.reviewer_name || r.name || '',
            body: stripHtml(r.body || r.content || r.body_html || ''),
            verified: !!(r.verified_buyer || r.verified === 'buyer' || reviewer.verified_buyer),
            pictures: pics,
            product_title: r.product_title || r.product_name || product.title || product.name || '',
            product_handle: r.product_handle || product.handle || '',
            product_url: r.product_url || product.url || product.link || ''
          },
          null
        )
      );
    }
    return out;
  }

  function unique(list) {
    var seen = {};
    var out = [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (!list[i] || seen[list[i].id]) continue;
      seen[list[i].id] = true;
      out.push(list[i]);
    }
    return out;
  }

  class TtlBaReviews extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.track = this.querySelector('[data-ttl-bar-track]');
      this.prev = this.querySelector('[data-ttl-bar-arrow="prev"]');
      this.next = this.querySelector('[data-ttl-bar-arrow="next"]');
      if (!this.track) return;
      this._bindDrag();
      this._bindArrows();
      this.track.addEventListener('scroll', this.sync.bind(this), { passive: true });
      this._resize = new ResizeObserver(this.sync.bind(this));
      this._resize.observe(this.track);
      this.reviewLabels = reviewLabelsFromRoot(this);
      if (this.getAttribute('data-source') === 'judgeme') {
        this.loadJudgeMe();
      } else {
        this.sync();
      }
    }

    disconnectedCallback() {
      if (this._resize) this._resize.disconnect();
    }

    cardStep() {
      var card = this.track.querySelector('.ttl-bar__card:not(.ttl-bar__card--skel)');
      if (!card) card = this.track.querySelector('.ttl-bar__card');
      if (!card) return this.track.clientWidth;
      var styles = window.getComputedStyle(this.track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(dir) {
      this.track.scrollBy({ left: dir * this.cardStep(), behavior: 'smooth' });
    }

    sync() {
      var el = this.track;
      var max = el.scrollWidth - el.clientWidth - 2;
      this.toggleAttribute('data-ttl-bar-scrollable', max > 2);
      if (this.prev) this.prev.disabled = el.scrollLeft <= 2;
      if (this.next) this.next.disabled = el.scrollLeft >= max;
    }

    _bindArrows() {
      var self = this;
      this.querySelectorAll('[data-ttl-bar-arrow]').forEach(function (button) {
        button.addEventListener('click', function () {
          var dir = button.getAttribute('data-ttl-bar-arrow') === 'prev' ? -1 : 1;
          self.scrollByCard(dir);
        });
      });
    }

    _bindDrag() {
      var track = this.track;
      var down = false;
      var isMouse = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      track.addEventListener('pointerdown', function (e) {
        isMouse = e.pointerType === 'mouse';
        if (!isMouse) return;
        down = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!down || !isMouse) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
          moved = true;
          track.setAttribute('data-ttl-grabbing', '');
          try {
            track.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
        if (moved) {
          e.preventDefault();
          track.scrollLeft = startScroll - dx;
        }
      });

      function endDrag(e) {
        if (!down) return;
        down = false;
        track.removeAttribute('data-ttl-grabbing');
        if (e && e.pointerId != null) {
          try {
            track.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    }

    loadJudgeMe() {
      var bootEl = this.querySelector('[data-ttl-bar-bootstrap]');
      var boot = null;
      if (bootEl) {
        try {
          boot = JSON.parse(bootEl.textContent || 'null');
        } catch (e) {
          boot = null;
        }
      }
      var labels = this.reviewLabels || defaultReviewLabels();
      var bootList = this.filterReviews(
        collectReviews(boot).map(function (r) {
          return applyReviewDisplay(r, labels);
        })
      );
      if (bootList.length) this.renderReviews(bootList);

      var token = this.getAttribute('data-token') || '';
      var shop = this.getAttribute('data-shop-domain') || '';
      if (!token || !shop) {
        if (!bootList.length) this.useFallback();
        return;
      }

      var self = this;
      this.setAttribute('aria-busy', 'true');
      this.fetchPhotoReviews(shop, token)
        .then(function (list) {
          if (list.length) self.renderReviews(list);
          else if (!bootList.length) self.useFallback();
        })
        .catch(function () {
          if (!bootList.length) self.useFallback();
        })
        .finally(function () {
          self.removeAttribute('aria-busy');
        });
    }

    filterReviews(list) {
      var min = parseInt(this.getAttribute('data-min-rating'), 10) || 1;
      var limit = parseInt(this.getAttribute('data-limit'), 10) || 8;
      return unique(list)
        .filter(function (r) {
          return r.pictures.length && r.rating >= min && (r.body || r.name);
        })
        .slice(0, Math.max(4, Math.min(limit, 12)));
    }

    fetchPhotoReviews(shop, token) {
      var self = this;
      var limit = parseInt(this.getAttribute('data-limit'), 10) || 8;
      var page = 1;
      var merged = [];
      var maxPages = 3;

      function next() {
        var params = new URLSearchParams({
          shop_domain: shop,
          api_token: token,
          page: String(page),
          per_page: '20',
          json_request: 'true',
          sort_by: 'with_pictures'
        });
        return fetch(JM_API + '?' + params.toString())
          .then(function (res) {
            if (!res.ok) throw new Error('jm ' + res.status);
            return res.json();
          })
          .then(function (data) {
            merged = unique(
              merged.concat(
                collectReviews(data).map(function (r) {
                  return applyReviewDisplay(r, self.reviewLabels);
                })
              )
            );
            var filtered = self.filterReviews(merged);
            var totalPages = Number(data && data.total_pages) || 1;
            if (filtered.length >= limit || page >= totalPages || page >= maxPages) {
              return filtered;
            }
            page += 1;
            return next();
          });
      }

      return next();
    }

    useFallback() {
      var tpl = this.querySelector('[data-ttl-bar-fallback]');
      if (!tpl || !tpl.content) {
        this.sync();
        return;
      }
      this.track.innerHTML = '';
      this.track.appendChild(tpl.content.cloneNode(true));
      this.sync();
    }

    renderReviews(list) {
      var verifiedLabel = this.getAttribute('data-verified') || '';
      var rootUrl = (this.getAttribute('data-root-url') || '/').replace(/\/$/, '');
      var labels = this.reviewLabels || defaultReviewLabels();
      this.track.innerHTML = list
        .map(function (r) {
          return cardHtml(
            applyReviewDisplay(
              {
                pictures: r.pictures,
                name: r.name,
                verified: true,
                body: r.body,
                rating: r.rating,
                product_title: r.product_title,
                product_handle: r.product_handle,
                product_url: r.product_url
              },
              labels
            ),
            verifiedLabel,
            rootUrl
          );
        })
        .join('');
      this.track.scrollLeft = 0;
      this.sync();
    }
  }

  function productHref(url, rootUrl) {
    if (!url) return '';
    if (/^https?:\/\//i.test(url)) {
      try {
        var parsed = new URL(url);
        return parsed.pathname + parsed.search;
      } catch (e) {
        return url;
      }
    }
    if (url.charAt(0) === '/') return rootUrl + url;
    return rootUrl + '/' + url;
  }

  function starsHtml(rating) {
    var n = Math.round(Number(rating) || 0);
    var s = '';
    var i;
    for (i = 1; i <= 5; i++) {
      s +=
        '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" focusable="false"' +
        (i <= n ? '' : ' class="is-off"') +
        '>' +
        STAR_PATH +
        '</svg>';
    }
    return '<div class="ttl-bar__stars" aria-hidden="true">' + s + '</div>';
  }

  function cardHtml(r, verifiedLabel, rootUrl, opts) {
    opts = opts || {};
    var src = r.pictures && r.pictures[0] ? r.pictures[0].replace(/"/g, '') : '';
    var alt = escapeHtml(r.name || '');
    var media = '';
    if (src) {
      var img =
        '<img class="ttl-bar__img" src="' +
        escapeHtml(src) +
        '" alt="' +
        alt +
        '" loading="lazy">';
      if (opts.openPhotos) {
        img =
          '<button type="button" class="ttl-bar__img-btn" data-ttl-jm-open="' +
          encodeURIComponent(r.pictures[0]) +
          '" aria-label="' +
          alt +
          '">' +
          img +
          '</button>';
      }
      media =
        '<div class="ttl-bar__media"><div class="ttl-bar__half ttl-bar__half--solo">' +
        img +
        '</div></div>';
    }

    var author = '';
    if (r.name || (r.verified && verifiedLabel)) {
      author = '<div class="ttl-bar__author">';
      if (r.name) author += '<span class="ttl-bar__name">' + escapeHtml(r.name) + '</span>';
      if (r.verified && verifiedLabel) {
        author +=
          '<span class="ttl-bar__verified">' + CHECK_SVG + escapeHtml(verifiedLabel) + '</span>';
      }
      author += '</div>';
    }

    var quote = r.body
      ? '<div class="ttl-bar__quote">' + escapeHtml(r.body) + '</div>'
      : '';

    var product = '';
    var href = productHref(r.product_url, rootUrl);
    if (r.product_title && href) {
      product =
        '<a class="ttl-bar__product" href="' +
        escapeHtml(href) +
        '"><span class="ttl-bar__product-label">' +
        escapeHtml(r.product_title) +
        '</span>' +
        ARROW_SVG +
        '</a>';
    } else if (r.product_title) {
      product =
        '<span class="ttl-bar__product"><span class="ttl-bar__product-label">' +
        escapeHtml(r.product_title) +
        '</span></span>';
    }

    return (
      '<article class="ttl-bar__card' +
      (src ? '' : ' ttl-bar__card--text') +
      '">' +
      media +
      '<div class="ttl-bar__body">' +
      author +
      starsHtml(r.rating) +
      quote +
      product +
      '</div></article>'
    );
  }

  window.ttlRenderBarCard = cardHtml;

  customElements.define('ttl-ba-reviews', TtlBaReviews);
})();
